import { render } from "./05_VerifyPage.vue?vue&type=template&id=9920d23a&scoped=true"
import script from "./05_VerifyPage.vue?vue&type=script&lang=js"
export * from "./05_VerifyPage.vue?vue&type=script&lang=js"

import "./05_VerifyPage.vue?vue&type=style&index=0&id=9920d23a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9920d23a"]])

export default __exports__